import React, {useEffect, useState} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input} from 'reactstrap';
import {validMail, validPassword, validString} from "../../validation";
import PropTypes from "prop-types";
import connect from "react-redux/es/connect/connect";
import {setErrorProfile, login} from "../../reducers/profile/actions";

function ModalLogin({isLoaded, isError, login, clearError, toggle, setSuccessText, toggleSuccess, isOpen, toggleRestore}) {

    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');
    const [prevOpen, setPrevOpen] = useState(false);

    useEffect(() => {
        if (isOpen && isError) {
            clearError();
            alert('Invalid Data');
        }

        if (prevOpen !== isOpen) {
            if (isOpen) {
                initState();
            }
            setPrevOpen(isOpen);
        }
    });

    function initState() {
        setEmail('');
        setPass('');
    }

    const sendForm = () => {
        if (validEmail() && validPass()) {
            const data = {email: email.trim(), password: pass.trim()},
                successCB = () => {
                    toggle();
                };
            return login({data, successCB})
        }
        if (!validEmail()) {
            alert('Invalid Email');
            return;
        }
        if (!validPass()) {
            alert('Invalid Password');
        }
    };

    const handleInputPass = (evt) => setPass(evt.target.value);
    const handleInputEmail = (evt) => setEmail(evt.target.value);

    function validEmail() {
        const str = email.trim();
        return validString(str) && validMail(str)
    }

    function validPass() {
        console.log('pass x1gStK: ', pass);
        const str = pass.trim();
        return validString(str) && validPassword(str)
    }

    const toggleRestorePass = () => {
        toggle();
        toggleRestore();
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            sendForm();
        }
    };

    return (
        <div>
            <Modal isOpen={isOpen}>
                <ModalHeader toggle={isLoaded ? null : toggle}>Login</ModalHeader>
                <ModalBody>
                    <Form onSubmit={sendForm}>
                        <FormGroup>
                            <Label for="exampleEmail">Email</Label>
                            <Input type="email" name="email" id="exampleEmail" placeholder="Email"
                                   value={email} onChange={handleInputEmail} onKeyPress={handleKeyPress}/>
                        </FormGroup>
                        <FormGroup>
                            <Label for="examplePassword">Password</Label>
                            <Input type="password" name="password" id="examplePassword"
                                   placeholder="Password" value={pass} onKeyPress={handleKeyPress}
                                   onChange={handleInputPass}/>
                        </FormGroup>
                    </Form>
                    <a className={'link'} onClick={toggleRestorePass}>I forgot my password</a>
                </ModalBody>
                <ModalFooter>
                    <button className={`btn third ${isLoaded ? " disabled" : ''}`}
                            onClick={isLoaded ? null : sendForm}>Login
                    </button>
                    {' '}
                    <button className={`btn first ${isLoaded ? " disabled" : ''}`}
                            onClick={isLoaded ? null : toggle}>Cancel
                    </button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

ModalLogin.propTypes = {
    login: PropTypes.func,
    clearError: PropTypes.func,
    isLoaded: PropTypes.bool,
    isError: PropTypes.bool,
    toggle: PropTypes.func,
    setSuccessText: PropTypes.func,
    toggleSuccess: PropTypes.func,
    isOpen: PropTypes.bool,
    toggleRestore: PropTypes.func,
};

export default connect(null, (dispatch) => (
    {
        login: (data) => dispatch(login(data)),
        clearError: () => dispatch(setErrorProfile(false)),
    })
)(ModalLogin);
